<div id="informationview" class="informationview" [ngClass]="{'transparent-background' : this.backgroundVideoIsActive}">
  <div id="widgetcontainer" class="widget-container">
    <ng-template #widgetWrapperInsertionPoint></ng-template>
  </div>
  <!-- This is the global container for user notifications(toasts) -->
  <notifier-container></notifier-container>
</div>

<div class="widget-menu"
  [@widgetMenu]="widgetMenuIsOpen ? 'open' : 'closed'"
  [ngClass]="{'transparent-background' : this.backgroundVideoIsActive}">

  <button mat-icon-button class="menu-icon" [ngClass]="widgetMenuIsOpen ? 'menu-icon--open' : 'menu-icon--closed'" *ngIf="widgetTypes" (click)="toggleWidgetMenu($event)">
    <mat-icon>keyboard_arrow_down</mat-icon>
  </button>

  <div class="widget-menu__toggle" *ngFor="let widgetType of this.widgetTypes">
    <input class="widget-menu__checkbox" type="checkbox"
      [id]="widgetType.name"
      [checked]="widgetType.active"
      (change)="onWidgetActivityChanged(widgetType.name, $event)"
    >
    <label class="widget-menu__label"
      [ngClass]="{ 'widget-menu__label--is-active' : widgetType.active }"
      [for]="widgetType.name"
    >
      {{'widgets.' + widgetType.name + '.name' | translate}}
    </label>
  </div>
</div>
